import PlanCard from './planCard';

export default PlanCard;
